import { FC, memo } from "react";
import { AppShell } from "@mantine/core";
import { motion, AnimatePresence } from "framer-motion";
import { useFooterVisibility } from "@shared/utils";
import { footerVariants } from "./Animations";

import styles from "./Footer.module.scss";
import { NavLinks } from "./Components";

const FooterComponent: FC = () => {
  const shouldShowFooter = useFooterVisibility();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key="footer"
        variants={footerVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        className={styles.footer}
        style={{ visibility: shouldShowFooter ? "visible" : "hidden" }}
      >
        <AppShell.Footer className={styles.footerContent}>
          <NavLinks />
        </AppShell.Footer>
      </motion.div>
    </AnimatePresence>
  );
};

export const Footer = memo(FooterComponent, () => true);
